<template>
  <div class="caseView" style="margin-bottom:60px">
    <div class="title">助力各市场完成智慧化升级</div>
    <div class="info">
      安宣护航：定制化服务、护航市场稳定、数据安全、消费者体验~
    </div>
    <div class="numberItem">
      <div class="caseNumber" v-for="(item, index) in numData" :key="index">
        <div class="header">
          <span class="big">{{ item.number }}</span>
          <span class="small">+</span>
        </div>
        <div class="infoText">{{ item.text }}</div>
      </div>
    </div>
    <div class="imgItem">
      <div class="imgBox" v-for="(item, index) in caseData" :key="index">
        <img class="caseImg" :src="item.src" alt="" />
        <div class="caseTitle">{{ item.title }}</div>
        <div class="caseInfo">{{ item.text }}</div>
      </div>
    </div>
    <!-- <div class="btn">查看跟多案例</div> -->
  </div>
</template>
<script>
export default {
  data() {
    return {
      numData: [
        {
          start:0,
          number: 10,
          text: "十多年技术沉淀，获颁国家高新技术企业",
        },
        {
          start:0,
          number: 500,
          text: "五百多家智慧农贸市场成功案例",
        },
        {
          start:0,
          number: 10000,
          text: "追溯系统覆盖一万多家大中型商超，批发配送企业",
        },
      ],
      caseData: [
        {
          src: "/static/newHomeImg/case/img_PujiangCenter_1.png",
          title: "浦江中心农贸市场",
          text: "五化农贸服务案例",
        },

        {
          src: "/static/newHomeImg/case/img_ShaoxingMarket_2.png",
          title: "绍兴粮食批发市场",
          text: "五化农批服务案例",
        },
        {
          src: "/static/newHomeImg/case/img_Shandongmelon_3.png",
          title: "山东省富硒甜瓜追溯",
          text: "农产品追溯服务案例",
        },
        {
          src: "/static/newHomeImg/case/img_SongyangCounty_4.png",
          title: "松阳县教育局",
          text: "阳光食堂服务案例",
        },
        {
          src: "/static/newHomeImg/case/img_RedStarMacalline_5.png",
          title: "红星美凯龙",
          text: "五化专业市场服务案例",
        },
        {
          src: "/static/newHomeImg/case/img_Zhejiangkeo_6.png",
          title: "浙江科奥机电五金市场",
          text: "五化专业市场服务案例",
        },
      ],
    };
  },

  created(){},
  mounted(){
     window.addEventListener('scroll', this.getScroll);
  },
  methods:{
    getScroll(){

        //   let  scrollTop =
				// 	window.pageYOffset ||
				// 	document.documentElement.scrollTop ||
				// 	document.body.scrollTop;
        //   // console.log(scrollTop)

        // window.onresize = function() { //监听屏幕的改变

				// document.documentElement.style.fontSize = document.documentElement.clientWidth / 7.5 + 'px';
			// };

    },
    getData(start,end,number){
      let timer = setInterval(()=>{
        if(start<end){
          start = start+number
        }
      },3000)
    }
  }
};
</script>
<style scoped>
.caseView {
  width: 1200px;
  margin: 87px auto 0;
  text-align: center;
}
.caseView .title {
  height: 31px;
  font-size: 30px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 28px;
  margin-bottom: 49px;
}
.caseView .info {
  width: 1199px;
  height: 64px;
  line-height: 64px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #25384E;

  background: #f4f9ff;
  text-align: center;
}
.numberItem {
  display: flex;
  justify-content: space-around;
}
.numberItem .header {
  margin: 52px 0 19px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  font-style: italic;
  color: #0075ff;
  line-height: 28px;
}
.numberItem .caseNumber {
  width: 400px;
}
.numberItem .header .big {
  font-size: 42px;
}
.numberItem .header .small {
  font-size: 20px;
  font-family: Microsoft YaHei;
}
.numberItem .infoText {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #7b7b7b;
  line-height: 28px;
}

.imgItem {
  display: flex;
  flex-wrap: wrap;
}
.imgItem .imgBox {
  width: 332px;
  height: 363px;
  margin-right: 102px;
  margin-top: 42px;
}
.imgItem .imgBox .caseImg {
  width: 332px;
  height: 272px;
  border-radius: 5px 5px 0px 0px;
}
.imgItem .imgBox:nth-of-type(3n) {
  margin-right: 0;
}
.caseTitle {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #141414;
  line-height: 22px;
  margin: 20px 0 15px 23px;
  text-align: left;
}
.caseInfo {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #555e71;
  line-height: 22px;
  position: relative;
  text-align: left;
  padding-left: 40px;
}
.caseInfo::before {
  content: " ";
  position: absolute;
  left: 24px;
  bottom: 7px;
  font-size: 20px;
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #535E71;
  border-radius: 50%;

}
.btn {
  margin: 42px auto 94px;
  width: 178px;
  height: 42px;
  background: #ffffff;
  border: 1px solid #2589ff;
  border-radius: 2px;

  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #2589ff;
  line-height: 42px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/page/newHomePage/caseView.vue